import gql from 'graphql-tag'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import LinearProgress from '@material-ui/core/LinearProgress'
import { Query } from '@apollo/client/react/components'
import ButtonCta from '@components/atoms/button-cta'
import useStyles from './event-card-banner.styles'

export const GET_BANNER_DATA = gql`
  query getBannerData($title: String!) {
    tokenCollection(where: { title: $title }, limit: 1) {
      items {
        title
        text
        link
      }
    }
  }
`

const EVENT_CARD_BANNER_HEADLINE = 'Find golf experiences made for you'
const EVENT_CARD_BANNER_SUMMARY = 'Explore lessons, programs and events based on your goals and where you are in your golf journey.'
export const EVENT_CARD_BANNER_PHOTO = '/images/event-card-banner-golf-experiences.jpg'
export const EVENT_CARD_BANNER_PHOTO_ALT = 'Women practicing putting at a golf clinic'
export const EVENT_CARD_BANNER_LOGO = '/images/logo-white.svg'
export const EVENT_CARD_BANNER_LOGO_ALT = 'PGA of America Logo'

export function EventCardBannerView({
  headline,
  eyebrow,
  text,
  link,
}) {
  const styles = useStyles()

  return (
    <section className={styles.root} data-testid="event-card-banner">
      <div className={styles.media}>
        <img
          className={styles.photo}
          src={EVENT_CARD_BANNER_PHOTO}
          alt={EVENT_CARD_BANNER_PHOTO_ALT}
        />
      </div>
      <div className={styles.panel}>
        {headline ? (
          <Typography className={styles.headline} variant="h3" component="h2">
            {headline}
          </Typography>
        ) : null}
        {eyebrow ? (
          <Typography className={styles.summary} variant="body1">
            {eyebrow}
          </Typography>
        ) : null}
        {text && link ? (
          <ButtonCta
            className={styles.cta}
            color="primary"
            variant="outlined"
            href={link}
            arrow
          >
            {text}
          </ButtonCta>
        ) : null}
        <img
          className={styles.logo}
          src={EVENT_CARD_BANNER_LOGO}
          alt={EVENT_CARD_BANNER_LOGO_ALT}
        />
      </div>
    </section>
  )
}

EventCardBannerView.propTypes = {
  headline: PropTypes.string,
  eyebrow: PropTypes.string,
  text: PropTypes.string,
  link: PropTypes.string,
}

const EventCardBanner = () => (
  <Query query={GET_BANNER_DATA} variables={{ title: 'Event Card Banner' }}>
    {({ loading, error, data }) => {
      if (error) return null
      if (loading) return <LinearProgress color="secondary" />
      const item = data?.tokenCollection?.items?.[0]
      if (!item) return null

      return (
        <EventCardBannerView
          headline={EVENT_CARD_BANNER_HEADLINE}
          eyebrow={EVENT_CARD_BANNER_SUMMARY}
          text={item.text}
          link={item.link}
        />
      )
    }}
  </Query>
)

export default EventCardBanner
